import dialogPolyfill from 'dialog-polyfill';
// tiny-slider
import {tns} from '../../node_modules/tiny-slider/src/tiny-slider.js';

/** DOMTokenList */
// https://github.com/Alhadis/Fix-IE/edit/master/src/token-list.js
!function(){"use strict";var n,r,t,e,i=window,o=document,u=Object,f=null,a=!0,c=!1,l=" ",s="Element",d="create"+s,h="DOMTokenList",m="__defineGetter__",p="defineProperty",v="class",g="List",y=v+g,w="rel",L=w+g,_="div",b="length",j="contains",S="apply",k="HTML",E=("item "+j+" add remove toggle toString toLocaleString").split(l),A=E[2],C=E[3],M=E[4],N="prototype",O=p in u||m in u[N]||f,T=function(n,r,t,e){u[p]?u[p](n,r,{configurable:c===O?a:!!e,get:t}):n[m](r,t)},x=function(r,t){var e=this,i=[],o={},f=0,s=0,d=function(){if(f>=s)for(;f>s;++s)(function(n){T(e,n,function(){return h(),i[n]},c)})(s)},h=function(){var n,e,u=arguments,c=/\s+/;if(u[b])for(e=0;e<u[b];++e)if(c.test(u[e]))throw n=new SyntaxError('String "'+u[e]+'" '+j+" an invalid character"),n.code=5,n.name="InvalidCharacterError",n;for(i=(""+r[t]).replace(/^\s+|\s+$/g,"").split(c),""===i[0]&&(i=[]),o={},e=0;e<i[b];++e)o[i[e]]=a;f=i[b],d()};return h(),T(e,b,function(){return h(),f}),e[E[6]]=e[E[5]]=function(){return h(),i.join(l)},e.item=function(n){return h(),i[n]},e[j]=function(n){return h(),!!o[n]},e[A]=function(){h[S](e,n=arguments);for(var n,u,c=0,s=n[b];s>c;++c)u=n[c],o[u]||(i.push(u),o[u]=a);f!==i[b]&&(f=i[b]>>>0,r[t]=i.join(l),d())},e[C]=function(){h[S](e,n=arguments);for(var n,u={},c=0,s=[];c<n[b];++c)u[n[c]]=a,delete o[n[c]];for(c=0;c<i[b];++c)u[i[c]]||s.push(i[c]);i=s,f=s[b]>>>0,r[t]=i.join(l),d()},e[M]=function(r,t){return h[S](e,[r]),n!==t?t?(e[A](r),a):(e[C](r),c):o[r]?(e[C](r),c):(e[A](r),a)},function(n,r){if(r)for(var t=0;7>t;++t)r(n,E[t],{enumerable:c})}(e,u[p]),e},D=function(n,r,t){T(n[N],r,function(){var n,e=this,i=m+p+r;if(e[i])return n;if(e[i]=a,c===O){for(var u,f=D.mirror=D.mirror||o[d](_),l=f.childNodes,s=l[b],h=0;s>h;++h)if(l[h]._R===e){u=l[h];break}u||(u=f.appendChild(o[d](_))),n=x.call(u,e,t)}else n=new x(e,t);return T(e,r,function(){return n}),delete e[i],n},a)};if(i[h])r=o[d](_)[y],N=i[h][N],r[A][S](r,E),2>r[b]&&(t=N[A],e=N[C],N[A]=function(){for(var n=0,r=arguments;n<r[b];++n)t.call(this,r[n])},N[C]=function(){for(var n=0,r=arguments;n<r[b];++n)e.call(this,r[n])}),r[M](g,c)&&(N[M]=function(r,t){var e=this;return e[(t=n===t?!e[j](r):t)?A:C](r),!!t});else{if(O)try{T({},"support")}catch(G){O=c}x.polyfill=a,i[h]=x,D(i[s],y,v+"Name"),D(i[k+"Link"+s],L,w),D(i[k+"Anchor"+s],L,w),D(i[k+"Area"+s],L,w)}}();

let doc = document,
    html = doc.documentElement,
    body = doc.body,
    win = window,
    raf = win.requestAnimationFrame
          || win.webkitRequestAnimationFrame
          || win.mozRequestAnimationFrame
          || win.msRequestAnimationFrame
          || function(cb) { return setTimeout(cb, 16); },
    active_cl = 'show',
    initializeClass = 'initialized',
    data_cl_attrs = ['data-toggle', 'data-add', 'data-remove'];

// remove "no-js" class
html.className = html.className.replace('no-js', 'js');

// skip link
let skiplink = doc.querySelector('.skip-link');
skiplink && skiplink.addEventListener('click', function(e) {
  e.preventDefault();
  doc.querySelector(e.target.getAttribute('href')).focus();
});

// button functions
doc.addEventListener('click', (e) => {
  let el = lookupByAttrs(e.target, data_cl_attrs);
  if (el) {
    let attr = el.hasAttribute(data_cl_attrs[0]) ? data_cl_attrs[0] :
               el.hasAttribute(data_cl_attrs[1]) ? data_cl_attrs[1] :
               data_cl_attrs[2],
        target = doc.querySelector(el.getAttribute(attr));

    if (target) {
      let cl = el.getAttribute('data-toggle-class') || active_cl;

      if (attr === data_cl_attrs[0]) {
        target.classList.toggle(cl);
        el.classList.toggle('active');
      } else if (attr === data_cl_attrs[1]) {
        target.classList.add(cl);
      } else {
        target.classList.remove(cl);
      }

      if (el.hasAttribute('href')) { e.preventDefault(); }
    }
  }
});
doc.addEventListener('click', (e) => {
  let attr = 'data-toggle-self',
      el = lookupByAttrs(e.target, [attr]);
  if (el) {
    let cl = el.getAttribute(attr);
    if (cl) {
      el.classList.toggle(cl);
      e.preventDefault();
    }
  }

  let searchline = lookupByClass(e.target, 'search-line'),
      table = lookupByAttr(e.target, 'data-action-count');
  if (!searchline) {
    let arr = doc.querySelectorAll('.datalist.show');
    if (arr.length) {
      forEach(arr, (datalist) => { datalist.classList.remove(active_cl); });
    }
  }
  if (table) {
    let active_btns = table.querySelectorAll('button.active');
    if (active_btns.length) {
      let tr = lookupByType(e.target, 'tr'),
          trs = table.querySelectorAll('tbody tr'),
          count = trs.length - (indexOf(trs, tr) + 1);
      table.setAttribute('data-push', Number(table.getAttribute('data-action-count')) - count);
      table.classList.add('expand');
    } else {
      table.classList.remove('expand');
    }
  }
});
doc.addEventListener('click', (e) => {
  let attr = 'data-delete-child',
      el = lookupByAttr(e.target, [attr]);
  if (el) {
    let target = lookupByAttr(el, 'data-delete-parent');
    if (target) {
      target.parentNode.removeChild(target);
    }
  }
});

let toggle_parent_attr = 'data-toggle-parent',
    toggle_parent_btns = doc.querySelectorAll('[' + toggle_parent_attr + ']');
if (toggle_parent_btns.length) {
  forEach(toggle_parent_btns, (btn) => {
    let target = lookupByClass(btn, btn.getAttribute(toggle_parent_attr));
    if (target) {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        target.classList.toggle(active_cl);
        btn.classList.toggle('active');
      });
    }
  });
}

// rating
let ratings = doc.querySelectorAll('.js-rating'),
    updateRating = function (el, parent) {
      if (el === parent) { return false; }
      parent.setAttribute('data-star', indexOf(parent.children, el) + 1);
    };
if (ratings.length) {
  forEach(ratings, (rating) => {
    rating.addEventListener('click', (e) => { updateRating(e.target, rating); });
    rating.addEventListener('mouseover', (e) => { updateRating(e.target, rating); });
  });
}


// toggle view mode
let view_toggle_tools = doc.querySelectorAll('.js-view-toggle-tools');
if (view_toggle_tools.length) {
  let attr_vm = 'data-view-mode',
      attr_this = 'data-this',
      data_cl = {
        'grid': 'l-gallery4',
        'list': 'list divider md'
      };
  forEach(view_toggle_tools, (tools) => {
    let ul = doc.querySelector(tools.getAttribute('data-target'));
    if (ul) {
      tools.addEventListener('click', (e) => {
        let el = lookupByAttr(e.target, attr_this);
        if (el) {
          let mode = el.getAttribute(attr_this);
          if (mode) {
            if (tools.getAttribute(attr_vm) !== mode) {
              tools.setAttribute(attr_vm, mode);
              ul.setAttribute(attr_vm, mode);
              ul.className = data_cl[mode] + ' no-bullet';
            }
          }
        }
      });
    }
  });
}

// change font size
let fontsize_tools = doc.querySelectorAll('.js-fontsize');
if (fontsize_tools.length) {
  forEach(fontsize_tools, (el) => {
    let article_attr = 'data-fontsize',
        article = lookupByAttr(el, article_attr);
    if (article) {
      el.addEventListener('click', (e) => {
        let fzattr = 'data-fontsize-action',
            btn = lookupByAttr(e.target, fzattr);
        if (btn) {
          let current = parseInt(article.getAttribute(article_attr)),
              number = parseInt(btn.getAttribute(fzattr));
          if (!current && current !== 0) { current = 0; }
          if (!number && number !== 0) { number = 0; }
          article.setAttribute(article_attr, number ? Math.min(3, Math.max(-2, current + number)) : 0);
        }
      });
    }
  });
}

// dialog
// (function() {
// var dialogPolyfill = dialogPolyfill ? dialogPolyfill : null;
// if (!dialogPolyfill) {
//   console.log('dialogPolyfill not loaded. Skip registering dialogs');
//   return false;
// }
let dialogs = doc.querySelectorAll('dialog');
if (dialogs.length) {
  forEach(dialogs, (dialog) => {
    dialogPolyfill.registerDialog(dialog);
  });
  doc.addEventListener('click', (e) => {
    let dialog_attr = 'data-dialog',
        open_btn = lookupByAttr(e.target, dialog_attr),
        close_btn = lookupByClass(e.target, 'js-dialog-close'),
        dialog;
    if (open_btn) {
      let selector = open_btn.getAttribute(dialog_attr);
      if (selector) { dialog = doc.querySelector(selector); }
      if (dialog) { dialog.showModal(); }
    }
    if (close_btn) {
      dialog = lookupByType(close_btn, 'dialog');
      if (dialog) { dialog.close(); }
    }
  });
}
// })();

// social media platform
function add_social_change_event () {
  let social_media_platform_attr = 'data-social-platform',
      cl_change_event = 'has-change-event',
      selects = doc.querySelectorAll('[' + social_media_platform_attr + '] select:not(.' + cl_change_event + ')');
  if (selects.length) {
    forEach(selects, (select) => {
      let box = lookupByAttr(select, social_media_platform_attr);
      select.addEventListener('change', (e) => {
        if (select.value === 'Others') {
          box.setAttribute(social_media_platform_attr, 'customize');
        } else {
          box.setAttribute(social_media_platform_attr, 'regular');
        }

        forEach(box.querySelectorAll('input'), (input) => { input.value = ''; });
      });
      select.classList.add(cl_change_event);
    });
  }
}
add_social_change_event();

let switch_els = doc.querySelectorAll('.js-map-switch input'),
    attr_map = 'data-display';
if (switch_els.length) {
  forEach(switch_els, (el) => {
    el.addEventListener('change', (e) => {
      let container = lookupByAttr(el, attr_map);
      if (container) {
        let val = container.getAttribute(attr_map);
        container.setAttribute(attr_map, val === 'list' ? 'map' : 'list');
      }
    });
  });
}

let attr_search = 'data-list',
    input_datas = doc.querySelectorAll('[' + attr_search + ']');
if (input_datas.length) {
  forEach(input_datas, (el) => {
    let datalist = doc.querySelector(el.getAttribute(attr_search));
    el.addEventListener('focus', (e) => { datalist.classList.add(active_cl); });
    // el.addEventListener('blur', (e) => { datalist.classList.remove(active_cl); });
    datalist.addEventListener('click', (e) => {
      let li = lookupByType(e.target, 'li', ['ul']);
      if (li) {
        el.value = li.textContent;
        datalist.classList.remove(active_cl);
      }
    });
  })
}

let sort_panels = doc.querySelectorAll('.js-sort-panel');
if (sort_panels.length) {
  forEach(sort_panels, (sort_panel) => {
    let arr = sort_panel.querySelectorAll('a'),
        clear_btn = sort_panel.querySelector('.js-sort-clear'),
        cl_active = 'active',
        aria_selected = 'aria-selected',
        title = sort_panel.parentNode.querySelector('.title'),
        prefix = '';
    if (title && (
        title.textContent.toLowerCase().indexOf('sort') >= 0 ||
        title.textContent.toLowerCase().indexOf('per page') >= 0
        )) { prefix = title.textContent + ' '; }
    if (title) { title.textContent = prefix + sort_panel.querySelector('li:first-child > a').textContent; }
    // events
    sort_panel.addEventListener('click', (e) => {
      let a = lookupByType(e.target, 'a', ['li', 'ul']);
          // cl_select = 'selected',
      if (a) {
        forEach(arr, (el) => {
          // if (el === a && !el.classList.contains(cl_select)) { el.classList.add(cl_select); }
          // if (el !== a && el.classList.contains(cl_select)) { el.classList.remove(cl_select); }
          if (el === a && !el.hasAttribute(aria_selected)) {
            el.setAttribute(aria_selected, 'true');
            let li = lookupByType(el, 'li', ['ul']);
            if (li) { li.classList.add(cl_active); }
            if (title) { title.textContent = prefix + a.textContent; }
          }
          if (el !== a && el.hasAttribute(aria_selected)) {
            el.removeAttribute(aria_selected);
            let li = lookupByType(el, 'li', ['ul']);
            if (li) { li.classList.remove(cl_active); }
          }
        });
        e.preventDefault();
      }
    });

    if (clear_btn) {
      clear_btn.addEventListener('click', (e) => {
        let lis = sort_panel.querySelectorAll('li.' + cl_active),
            as = sort_panel.querySelectorAll('a[' + aria_selected + ']');
        if (lis.length) {
          forEach(lis, (li) => { li.classList.remove(cl_active); });
        }
        if (as.length) {
          forEach(as, (a) => { a.removeAttribute(aria_selected); });
        }
      });
    }
  });
}


let print_els = doc.querySelectorAll('.js-print');
if (print_els.length) {
  body.classList.add('article-page');
  forEach(print_els, (print_el) => {
    print_el.addEventListener('click', (e) => {
      win.print();
      e.preventDefault();
    });
  });
}

// image carousel
let img_carousels = doc.querySelectorAll('.img-carousel'),
    change_image = function (el, thumbs, carousel) {
      if (!el || el === thumbs) { return false; }
      carousel.setAttribute('data-active', indexOf(thumbs.children, el) + 1);
    };
if (img_carousels.length) {
  forEach(img_carousels, (carousel) => {
    let thumbs = carousel.querySelector('.thumbs');
    if (thumbs) {
      thumbs.addEventListener('click', (e) => {
        change_image(e.target, thumbs, carousel);
      });
      // thumbs.addEventListener('mouseover', (e) => {
      //   change_image(e.target, thumbs, carousel);
      // });
    }
  });
}

// tabs-basic
let basic_tabs = doc.querySelectorAll('.js-basic-tabs');
if (basic_tabs.length) {
  forEach(basic_tabs, (tabs) => {
    let ul = tabs.querySelector('ul'),
        first_li = tabs.querySelector('li'),
        btn = tabs.querySelector('.expand'),
        section = lookupByType(tabs, 'nav');
    // // expand event
    // btn && btn.addEventListener('click', (e) => {
    //   tabs.classList.toggle('expanded');
    // });
    // // display expand button
    // if (ul.offsetHeight > first_li.offsetHeight) {
    //   tabs.classList.add('expandable');
    // } else {
    //   tabs.classList.remove('expandable');
    // }
    // activate items
    if (section) { section.setAttribute('data-tab-active', '1'); }
    tabs.addEventListener('click', (e) => {
      let el = lookupByType(e.target, 'a', ['li', 'ul', 'nav', 'div']);
      if (el) {
        e.preventDefault();
        let current = tabs.querySelector('[aria-selected="true"]');
        if ((current && current !== el) || !current) { el.setAttribute('aria-selected', 'true'); }
        if (current && current !== el) { current.removeAttribute('aria-selected'); }
        if (section) {
          section.setAttribute('data-tab-active', indexOf(ul.children, el.parentNode) + 1);
        }
      }
    });
    // resize event
    let ticking = false, w_width;
    win.addEventListener('resize', function(e) {
      if (!ticking) {
        raf(function() {
          if (w_width == null) {
            w_width = win.innerWidth;
          } else if (w_width !== win.innerWidth) {
            if (ul.offsetHeight > first_li.offsetHeight) {
              tabs.classList.add('expandable');
            } else {
              tabs.classList.remove('expandable');
            }
          }
          ticking = false;
        });
        ticking = true;
      }
    });
  });
}

let title_tabs = doc.querySelectorAll('.js-title-tabs');
if (title_tabs.length) {
  forEach(title_tabs, (tabs) => {
    let header = lookupByType(tabs, 'header', ['section']),
        attr_header = 'data-panel-active',
        attr_btn = 'aria-selected',
        btns = tabs.children;
    if (header) {
      header.setAttribute(attr_header, 1);
      tabs.addEventListener('click', (e) => {
        let el = lookupByType(e.target, 'button', ['h2', 'header', 'section']);
        if (el && el.getAttribute(attr_btn) !== 'true') {
          forEach(btns, (btn) => {
            if (btn.hasAttribute(attr_btn)) { btn.removeAttribute(attr_btn); }
          });
          el.setAttribute(attr_btn, 'true');
          header.setAttribute(attr_header, indexOf(btns, el) + 1);
        }
      });
    }
  });
}

// hide comments when click outside
let floated_comments = doc.querySelector('.floated-comments');
if (floated_comments) {
  win.addEventListener('click', (e) => {
    if (floated_comments.classList.contains('show')) {
      let box = lookupByClass(e.target, 'floated-comments'),
          btn = lookupByClass(e.target, 'comment');
      if (!box && !btn) {
        floated_comments.classList.remove('show');
      }
    }
  });
}
// data-scroll-to
function scroll_to () {
  let attr = 'data-scrollto',
      scrollBtns = doc.querySelectorAll('[' + attr + ']');

  if (scrollBtns.length) {
    forEach(scrollBtns, (btn) => {
      let des, selector = btn.getAttribute(attr);
      if (selector) { des = doc.querySelector(selector); }

      if (des && !btn.classList.contains(initializeClass)) {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          window.scrollTo({top: des.offsetTop - 10, left: 0, behavior: 'smooth'});
        });

        // add initialize class
        btn.classList.add(initializeClass);
      }
    });
  }
}
scroll_to();

// slider
let basic_sliders = doc.querySelectorAll('.slider-basic');
if (basic_sliders.length) {
  forEach(basic_sliders, (el) => {
    let wp = lookupByClass(el, 'slider-wp'),
        current = wp.querySelector('.controls-basic .current'),
        total = wp.querySelector('.controls-basic .total'),
        items = 1,
        options = {
          container: el,
          items: items,
          slideBy: 'page',
          loop: false,
          autoHeight: true,
          gutter: 10,
          prevButton: wp.querySelector('.controls-basic .prev') || false,
          nextButton: wp.querySelector('.controls-basic .next') || false,
          swipeAngle: 45,
          preventScrollOnTouch: 'auto',
          onInit: (info) => {
            if (current) { current.innerHTML = info.navCurrentIndex + 1; }
            if (total) { total.innerHTML = info.pages; }
            info.navContainer.className += ' visually-hidden';
          }
        };
    if (el.hasAttribute('data-items')) { items = parseInt(el.getAttribute('data-items')); }
    if (items > 1) {
      options.items = items - 1;
      options.gutter = el.hasAttribute('data-gutter') ? parseInt(el.getAttribute('data-gutter')) : 30;
      options.responsive = {
        960: { items: items }
      };
    }
    let slider = tns(options);
    if (slider && current) {
      slider.events.on('transitionStart', (info) => {
        current.innerHTML = info.navCurrentIndex + 1;
      });
    }
  });
}
let user_sliders = doc.querySelectorAll('.slider-user');
if (user_sliders.length) {
  forEach(user_sliders, (el) => {
    let wp = lookupByClass(el, 'slider-wp');
    let slider = tns({
          container: el,
          items: 6,
          slideBy: 'page',
          loop: false,
          autoHeight: true,
          nav: false,
          gutter: 10,
          prevButton: wp.querySelector('.controls .prev') || false,
          nextButton: wp.querySelector('.controls .next') || false,
          swipeAngle: 45,
          preventScrollOnTouch: 'auto',
          responsive: {
            960: { items: 7 },
            1200: { items: 8 },
            1280: { items: 6 },
          }
        });
  });
}
let mini_sliders = doc.querySelectorAll('.mini-slider');
if (mini_sliders.length) {
  forEach(mini_sliders, (el) => {
    let slider = tns({
      container: el,
      loop: false,
      gutter: 0,
      controlsText: ['<span class="icon-round md white"><span class="i-left-angle sm img"></span></span>', '<span class="icon-round md white"><span class="i-right-angle sm img"></span></span>'],
      swipeAngle: 45,
      nav: false,
      preventScrollOnTouch: 'auto'
    })
  });
}
let gallery_sliders = doc.querySelectorAll('.gallery-slider');
if (gallery_sliders.length) {
  forEach(gallery_sliders, (el) => {
    let slider = tns({
      container: el,
      loop: false,
      items: 2,
      gutter: 20,
      slideBy: 'page',
      controlsText: ['<span class="icon-round lg white"><span class="i-left-angle img"></span></span>', '<span class="icon-round lg white"><span class="i-right-angle img"></span></span>'],
      swipeAngle: 45,
      nav: false,
      preventScrollOnTouch: 'auto',
      responsive: {
        540: { items: 3 },
        600: { gutter: 30 },
        800: { items: 4}
      }
    });
  })
}
let tab_sliders = doc.querySelectorAll('.tab-slider');
if (tab_sliders.length) {
  forEach(tab_sliders, (el) => {
    let navC = doc.querySelector(el.getAttribute('data-controls')),
        startI = parseInt(el.getAttribute('data-current'));
    if (navC) {
      navC.addEventListener('click', (e) => {
        if (e.target && (e.target.nodeName.toLowerCase() === 'a' || lookupByType(e.target, 'a'))) { e.preventDefault(); }
      });
    }
    let slider = tns({
      container: el,
      navContainer: navC ? navC : null,
      controls: false,
      startIndex: startI ? startI : 0,
      gutter: 10,
      loop: false,
      touch: false,
      autoHeight: true,
      swipeAngle: 45,
      preventScrollOnTouch: 'auto'
    });
  })
}
let podcast_sliders = doc.querySelectorAll('.podcast-slider');
if (podcast_sliders.length) {
  forEach(podcast_sliders, (el) => {
    let controlsContainer = el.parentNode.querySelector('.podcast-slider-controls'),
        slider = tns({
      container: el,
      autoHeight: true,
      nav: false,
      loop: false,
      controlsContainer: controlsContainer || false,
      swipeAngle: 45,
      preventScrollOnTouch: 'auto'
    });
  });
}

// month date
let month_dates = doc.querySelectorAll('.js-month-date');
if (month_dates.length) {
  let map = {
    "January": 1,
    "February": 2,
    "March": 3,
    "April": 4,
    "May": 5,
    "June": 6,
    "July": 7,
    "August": 8,
    "September": 9,
    "October": 10,
    "November": 11,
    "December": 12
  };
  forEach(month_dates, (month_date) => {
    let month_selector = month_date.querySelector('.month'),
        date_selector = month_date.querySelector('.date'),
        year_selector = month_date.querySelector('.year'),
        update_date_selector = function (el_month, el_date, el_year) {
          let days = daysInMonth(map[el_month.value], parseInt(el_year.value)),
              current = parseInt(el_date.value),
              date = current <= days ? current : 0,
              code = '';
          for (var i = 1; i <= days; i++) {
            let str_selected = i === date ? ' selected' : '';
            code += '<option value="' + i + '"' + str_selected + '>' + i + '</option>'
          }
          el_date.innerHTML = code;
        };
    if (month_selector && date_selector && year_selector) {
      month_selector.addEventListener('change', (e) => {
        update_date_selector(month_selector, date_selector, year_selector);
      });
      year_selector.addEventListener('change', (e) => {
        update_date_selector(month_selector, date_selector, year_selector);
      });
    }
  })
}
function daysInMonth (month, year) {
  return new Date(year, month, 0).getDate();
}

// timer
let sso_tick_triggers = doc.querySelectorAll('.js-tick-trigger');
if (sso_tick_triggers.length) {
  forEach(sso_tick_triggers, (trigger) => {
    let tick = trigger.parentNode.querySelector('.sso-tick');
    if (tick) {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        if (!trigger.hasAttribute('data-is-active')) {
          trigger.setAttribute('disabled', 'true');
          trigger.setAttribute('data-is-active', 'true');
          let count = parseInt(tick.getAttribute('data-duration'));
          if (count > 0) {
            do_tick(trigger, tick, count);
          }
        }
      });
    }
  });
}

function do_tick (el, target, n) {
  if (n > 0) {
    target.setAttribute('datetime', 'PT' + n + 'S');
    target.innerHTML = n + 's';

    setTimeout((e) => {
      do_tick(el, target, n - 1);
    }, 1000);
  } else {
    target.setAttribute('datetime', 'PT' + target.getAttribute('data-duration') + 'S');
    target.innerHTML = '';
    el.removeAttribute('disabled');
    el.removeAttribute('data-is-active');
  }
}

// js-sortable-list
let sortable_lists = doc.querySelectorAll('.js-sortable-list');
if (sortable_lists.length) {
  forEach(sortable_lists, (list) => {
    // (B) MAKE ITEMS DRAGGABLE + SORTABLE
    var items = list.querySelectorAll('li, tr'), current = null;
    if (items.length) {
      forEach(items, (i) => {
        // (B1) ATTACH DRAGGABLE
        i.draggable = true;

        // (B2) DRAG START - YELLOW HIGHLIGHT DROPZONES
        i.addEventListener("dragstart", function (ev) {
          current = this;
          current.classList.add('current');
          forEach(items, (it) => {
            if (it != current) { it.classList.add("hint"); }
          });
        });

        // (B3) DRAG ENTER - RED HIGHLIGHT DROPZONE
        i.addEventListener("dragenter", function (evt) {
          // if (this != current) { this.classList.add("active"); }
          if (this != current) {
            let arr = list.querySelectorAll('tr, li'),
                currentpos = indexOf(arr, current),
                droppedpos = indexOf(arr, this);
            if (currentpos < droppedpos) {
              this.parentNode.insertBefore(current, this.nextSibling);
            } else {
              this.parentNode.insertBefore(current, this);
            }
          }
        });

        // (B4) DRAG LEAVE - REMOVE RED HIGHLIGHT
        i.addEventListener("dragleave", function () {
          this.classList.remove("active");
        });

        // (B5) DRAG END - REMOVE ALL HIGHLIGHTS
        i.addEventListener("dragend", function () {
          current = null;
          forEach(items, (it) => {
            it.classList.remove("current");
            it.classList.remove("hint");
            it.classList.remove("active");
          });
        });

        // (B6) DRAG OVER - PREVENT THE DEFAULT "DROP", SO WE CAN DO OUR OWN
        i.addEventListener("dragover", function (evt) {
          evt.preventDefault();
        });

        // (B7) ON DROP - DO SOMETHING
        i.addEventListener("drop", function (evt) {
          evt.preventDefault();
          // if (this != current) {
          //   let arr = list.querySelectorAll('tr, li'),
          //       currentpos = indexOf(arr, current),
          //       droppedpos = indexOf(arr, this);
          //   if (currentpos < droppedpos) {
          //     this.parentNode.insertBefore(current, this.nextSibling);
          //   } else {
          //     this.parentNode.insertBefore(current, this);
          //   }
          // }
        });
      });
    }
  });
}

// select location
let location_selects = doc.querySelectorAll('.js-select-location');
if (location_selects.length) {
  forEach(location_selects, (select) => {
    let location_attr = 'data-location',
        field = lookupByAttr(select, location_attr);
    if (field) {
      select.addEventListener('change', (e) => {
        field.setAttribute(location_attr, select.value);
      });
    }
  });
}

// duplicate
let duplicate_attr = 'data-duplicate',
    duplicate_buttons = doc.querySelectorAll('[' + duplicate_attr + ']');
if (duplicate_buttons.length) {
  forEach(duplicate_buttons, (btn) => {
    let source_selector = btn.getAttribute(duplicate_attr);
    if (source_selector) {
      let source = doc.querySelector(source_selector);
      if (source) {
        btn.addEventListener('click', (e) => {
          let div = doc.createElement('div'),
              source_clone = source.cloneNode(true),
              action_line_html = '<div class="form-action-line"><button class="pill primary" type="button"><span class="txt">save</span></button><button class="pill text" type="button" data-delete-child><span class="txt">Delete</span></button></div>';
          // div.className = 'form-padding-box spacing-b-sm bg-lighter cloned';
          div.className = 'spacing-b-sm';
          div.setAttribute('data-delete-parent', '');
          source_clone.classList.add('spacing-b-sm');

          // remove values, textarea content, selected options
          let hasValueEls = source_clone.querySelectorAll('[value]'),
              textareas = source_clone.querySelectorAll('textarea'),
              selects = source_clone.querySelectorAll('select');
          if (hasValueEls.length) {
            forEach(hasValueEls, (el) => { el.removeAttribute('value'); });
          }
          if (textareas) {
            forEach(textareas, (el) => { el.innerText = ''; });
          }
          if (selects) {
            forEach(selects, (el) => {
              forEach(el.options, (option) => { option.selected = false; });
            });
          }

          div.appendChild(source_clone);
          div.insertAdjacentHTML('beforeend', action_line_html);

          let line = btn.parentNode;
          line.parentNode.insertBefore(div, line);
        });
      }
    }
  });
}


// input clear
let input_clear_attr = 'data-input-clear',
    input_clear_btns = doc.querySelectorAll('[' + input_clear_attr + ']');
if (input_clear_btns.length) {
  forEach(input_clear_btns, (btn) => {
    let input = doc.querySelector(btn.getAttribute(input_clear_attr));
    if (input) {
      btn.addEventListener('click', (e) => { input.value = ''; });
    }
  })
}

// js-avatar-edit
let avatar_edit_fields = doc.querySelectorAll('.js-avatar-edit');
if (avatar_edit_fields.length) {
  forEach(avatar_edit_fields, (field) => {
    let input = field.querySelector('[type="file"'),
        img = field.querySelector('img');
    if (input && img) {
      input.addEventListener('change', (e) => {
        if (input.files && input.files[0]) {
          let reader = new FileReader();
          reader.addEventListener('load', (e) => {
            img.src = e.target.result;
          });

          reader.readAsDataURL(input.files[0]);
        }
      });
    }
  });
}

// lightbox
// let lb_gallerys = doc.querySelectorAll('.js-lightbox'),
//     lb_data = {},
//     lb_current,
//     lb_index = 0;
// if (lb_gallerys.length) {
//   forEach(lb_gallerys, (gallery) => {
//     let gallery_id = Math.random().toString(36).replace('0.', 'lightbox-'),
//         arr_img = [],
//         arr_caption = [];

//     // get images
//     forEach(gallery.querySelectorAll('a'), (a) => { arr_img.push(a.href); });
//     lb_data[gallery_id] = {};
//     lb_data[gallery_id].img = arr_img;

//     // get captions
//     if (gallery.hasAttribute('data-caption')) {
//       forEach(gallery.querySelectorAll('.caption'), (caption) => { arr_caption.push(caption.innerHTML); });
//       lb_data[gallery_id].caption = arr_caption;
//     }
//   });
// }

function makeEmbedFluid() {
  let embeds = doc.querySelectorAll('.embedded-content'),
      embedsLen = embeds.length,
      player = /www.youtube.com|player.vimeo.com|www.facebook.com\/plugins\/video.php|www.google.com\/maps\/embed/,
      wrapClass = 'fluid-wrapper',
      itemClass = 'fluid-item';

  if (embedsLen) {
    for(let i = embedsLen; i--;) {
      let embed = embeds[i],
          item = embed.querySelector('iframe');

      if (item && !item.classList.contains(itemClass) && item.src.search(player) > 0) {
        let width = Number(item.width),
            height = Number(item.height);

        if (height && width) {
          let ratio = (height / width) * 100,
              wrap = doc.createElement('div');
          wrap.className = wrapClass;

          embed.classList.remove('flex-video');
          embed.style.maxWidth = width + 'px';
          wrap.style.paddingBottom = ratio + '%';
          item.classList.add(itemClass);

          embed.insertBefore(wrap, item);
          wrap.appendChild(item);
        }
      }
    }
  }
}
makeEmbedFluid();



function forEach (arr, callback, scope) {
  for (var i = 0, l = arr.length; i < l; i++) {
    callback.call(scope, arr[i], i);
  }
}

function lookupByClass (el, cla) {
  if (el === body || el === html) { return null; }
  return el.classList && el.classList.contains(cla) ? el : lookupByClass(el.parentNode, cla);
}

function lookupByAttr (el, attr) {
  if (el === body || el === html) { return null; }
  return el.hasAttribute(attr) ? el : lookupByAttr(el.parentNode, attr);
}

function lookupByAttrs (el, attrs) {
  if (el === body || el === html) { return null; }

  let returnel;
  attrs.forEach((str) => {
    if (!returnel && el.hasAttribute(str)) { returnel = el; }
  });
  return returnel || lookupByAttrs(el.parentNode, attrs);
}

function lookupByType (el, node, arr) {
  if (arr == null || !arr.length) { arr = ['body']; }
  var name = el.nodeName.toLowerCase();
  if (arr.indexOf(name) >= 0) { return null; }
  return name !== node ? lookupByType(el.parentNode, node, arr) : el;
}

function getOffsetTop (el) {
  return el.getBoundingClientRect().top + document.documentElement.scrollTop;
}

function indexOf (array, item) {
  for (var i = 0; i < array.length; i++) {
    if (array[i] === item) { return i; }
  }
  return -1;
}

// print
// function beforeprint () {
//   if (body.classList.contains('article-page') ||
//       body.classList.contains('static-page') ||
//       body.classList.contains('search-results-page')) {

//     let mainClass = doc.querySelector('.full-article') ? '.full-article' : 'main',
//         printStr = 'printlinks',
//         printlinks = doc.querySelector(mainClass+' .'+printStr),
//         baseurl = 'https://www.christianpost.com';
//     if (!printlinks) {
//       let printlinks = doc.createElement('ul'),
//           printlinksStr = '',
//           article = doc.querySelector(mainClass);
//       if (article) {
//         printlinks.className = printStr;
//         let links = doc.querySelectorAll(mainClass+' a:not([href^="mailto:"])'),
//             linkorder = 1;

//         for (var i = 0; i < links.length; i++) {
//           let link = links[i],
//               href = link.getAttribute('href');

//           // if (href !== link.textContent && href !== baseurl && href !== baseurl+'/') {
//           if (href !== link.textContent && !lookupByClass(link, 'pagination')) {
//             if (href.indexOf('http') < 0) {
//               let connectStr = href.charAt(0) === '/' ? '':'/';
//               href = baseurl + connectStr + href;
//             }

//             printlinksStr += '<li>'+linkorder+'. '+href+'</li>';
//             link.insertAdjacentHTML('afterend', '<sup class="link-order"> ('+linkorder+')</sup>');

//             linkorder++;
//           }
//         }

//         printlinks.innerHTML = printlinksStr;
//         article.appendChild(printlinks);
//       }
//     }
//   }
// }

// window.onbeforeprint = beforeprint;
